import { render, staticRenderFns } from "./newyearP1.vue?vue&type=template&id=e52758ac&scoped=true&"
import script from "./newyearP1.vue?vue&type=script&lang=js&"
export * from "./newyearP1.vue?vue&type=script&lang=js&"
import style0 from "./newyearP1.vue?vue&type=style&index=0&id=e52758ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52758ac",
  null
  
)

export default component.exports